import React, { Component } from "react";

export default function MainContent({ errors, handleChange, selectedService }) {
  return (
    <div className="row " style={{ marginTop: '10px' }}>
      <div className="col-lg-12">
        <div className="row p-1">

          <div className="col-lg-6 col-12" >
            <div className="row align-items-center" >
              <div className="col-lg-1 col-2">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" name='selectedService' checked={selectedService.includes('Nanny ( 1 to 3 Years Baby )')} value='Nanny ( 1 to 3 Years Baby )' onChange={handleChange} style={{ border: errors.selectedService ? '2px solid red' : '' }} />
                </div>
              </div>
              <div className="col-lg-9 col-10">
                <div className="row ">
                  <div className="col-lg-12  first-text" >
                    <p>Nanny ( 1 to 3 Years Baby )</p>
                  </div>
                  <div className="col-lg-12 second-text">
                    <p>नैनी (1 से 3 साल का बच्चा)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className="col-lg-6 col-12" >
            <div className="row align-items-center" >
              <div className="col-lg-1 col-2">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" checked={selectedService.includes('Baby Sitter ( 4 to 10 Years child )')} name='selectedService' value='Baby Sitter ( 4 to 10 Years child )' onChange={handleChange} style={{ border: errors.selectedService ? '2px solid red' : '' }} />
                </div>
              </div>
              <div className="col-lg-10 col-10">
                <div className="row ">
                  <div className="col-lg-12 first-text mt-lg-0 mt-3" >
                    <p>Baby Sitter ( 4 to 10 Years child )</p>
                  </div>
                  <div className="col-lg-12 second-text">
                    <p>बैबीसिटर (4 से 10 साल का बच्चा)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>




          <div className="col-lg-6 mt-lg-3 col-12" >
            <div className="row align-items-center" >
              <div className="col-lg-1 col-2">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" name='selectedService' checked={selectedService.includes('Post Delivery Mother and New Born Baby Massage')} value='Post Delivery Mother and New Born Baby Massage' onChange={handleChange} style={{ border: errors.selectedService ? '2px solid red' : '' }} />
                </div>
              </div>
              <div className="col-lg-10 col-10">
                <div className="row ">
                  <div className="col-lg-12 first-text mt-lg-0 mt-3" >
                    <p>Post Delivery Mother and New Born Baby Massage</p>
                  </div>
                  <div className="col-lg-12 second-text">
                    <p>डिलीवरी के बाद मां और नवजात शिशु की मालिश</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 mt-lg-3 col-12" >
            <div className="row align-items-center" >
              <div className="col-lg-1 col-2">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" name='selectedService' checked={selectedService.includes('Japa Care ( New Mother and New Born Baby)')} value='Japa Care ( New Mother and New Born Baby)' onChange={handleChange} style={{ border: errors.selectedService ? '2px solid red' : '' }} />
                </div>
              </div>
              <div className="col-lg-9 col-10">
                <div className="row ">
                  <div className="col-lg-12 first-text mt-lg-0 mt-3" >
                    <p>Japa Care ( New Mother and New Born Baby)</p>
                  </div>
                  <div className="col-lg-12 second-text">
                    <p>जापा केयर (नई माँ और नवजात शिशु)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>



          <div className="col-lg-6 mt-lg-3 col-12" >
            <div className="row align-items-center" >
              <div className="col-lg-1 col-2">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" name='selectedService' checked={selectedService.includes('Patient / Elder Care')} value='Patient / Elder Care' onChange={handleChange} style={{ border: errors.selectedService ? '2px solid red' : '' }} />
                </div>
              </div>
              <div className="col-lg-9 col-10">
                <div className="row ">
                  <div className="col-lg-12 first-text mt-lg-0 mt-3" >
                    <p>Patient / Elder Care</p>
                  </div>
                  <div className="col-lg-12 second-text">
                    <p>रोगी / बुजुर्गों की देखभाल के लिए</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className="col-lg-6 mt-lg-3 col-12" >
            <div className="row align-items-center" >
              <div className="col-lg-1 col-2">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" name='selectedService' checked={selectedService.includes('House Maid / Cook')} value='House Maid / Cook' onChange={handleChange} style={{ border: errors.selectedService ? '2px solid red' : '' }} />
                </div>
              </div>
              <div className="col-lg-9 col-10">
                <div className="row ">
                  <div className="col-lg-12 first-text mt-lg-0 mt-3" >
                    <p>House Maid / Cook</p>
                  </div>
                  <div className="col-lg-12 second-text">
                    <p>घर का काम और खाना</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}